import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './Auth';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useContext(UserContext);

  // If no user is authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If admin access is required but user is not admin, redirect to main app
  if (adminOnly && !user.admin) {
    return <Navigate to="/chat" replace />;
  }

  return children;
};

export default ProtectedRoute;
